// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.OrderTwelve84ConfigurationOptionResponse */
/* istanbul ignore next */
@GandalfModel
export class OrderTwelve84ConfigurationOptionResponse extends GandalfModelBase {

	@GandalfArray(OrderTwelve84ConfigurationOptionResponse)
	children!: OrderTwelve84ConfigurationOptionResponse[] | null;

	@GandalfProperty({ designType: Boolean })
	defaultSelection!: boolean | null;

	@GandalfProperty({ designType: Number })
	locationProductId!: number | null;

	@GandalfConstantDecorator(constants.Twelve84SmartflowCode)
	@GandalfProperty({ designType: constants.Twelve84SmartflowCode })
	twelve84SmartflowCode!: constants.Twelve84SmartflowCode | null;

}
